import { render, staticRenderFns } from "./GettingStarted.vue?vue&type=template&id=143c1710"
import script from "./GettingStarted.vue?vue&type=script&lang=js"
export * from "./GettingStarted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/disk1/buildAgent/work/8268df4d62037a26/vAnalyticsJS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('143c1710')) {
      api.createRecord('143c1710', component.options)
    } else {
      api.reload('143c1710', component.options)
    }
    module.hot.accept("./GettingStarted.vue?vue&type=template&id=143c1710", function () {
      api.rerender('143c1710', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/modules/admin/components/Collector/GettingStarted.vue"
export default component.exports